import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getConfiguration,
  initializeClientContext,
} from "../redux/actions/action-creator";
import {
  selectConfigurationInitialized,
  selectConfigurationLoading,
} from "../redux/selectors/configurationSelectors";
import { ServicesSkeleton } from "./SkeletonLoader";

let configurationRequest = null;
let configurationBootstrapped = false;

const ConfigurationBootstrap = ({ children }) => {
  const dispatch = useDispatch();
  const configurationInitialized = useSelector(selectConfigurationInitialized);
  const configurationLoading = useSelector(selectConfigurationLoading);
  const [isReady, setIsReady] = useState(
    configurationBootstrapped && configurationInitialized
  );

  useEffect(() => {
    let isMounted = true;
    const clientContext = dispatch(initializeClientContext());

    if (configurationBootstrapped && configurationInitialized) {
      setIsReady(true);
      return () => {
        isMounted = false;
      };
    }

    if (!configurationRequest) {
      configurationRequest = dispatch(getConfiguration(clientContext))
        .catch(() => null)
        .finally(() => {
          configurationBootstrapped = true;
          configurationRequest = null;
        });
    }

    configurationRequest.finally(() => {
      if (isMounted) {
        setIsReady(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [configurationInitialized, dispatch]);

  if (!isReady || configurationLoading) {
    return <ServicesSkeleton />;
  }

  return children;
};

export default ConfigurationBootstrap;
